module.exports = __webpack_public_path__ + "static/media/Virtual-mirror-lens-4-psd_Fresh-HAZEL.ae1ad6a5.png";